import { Col, Row } from "react-bootstrap";
import { DiGit } from "react-icons/di";
import {
  SiDocker,
  SiGithubactions,
  SiGitlab,
  SiIntellijidea,
  SiJira,
  SiKubernetes,
  SiPostman,
  SiVercel,
  SiVisualstudiocode,
} from "react-icons/si";

const toolGroups = [
  {
    title: "Development",
    tools: [
      { name: "IntelliJ IDEA", icon: <SiIntellijidea /> },
      { name: "VS Code", icon: <SiVisualstudiocode /> },
      { name: "Git", icon: <DiGit /> },
      { name: "GitLab", icon: <SiGitlab /> },
    ],
  },
  {
    title: "API & Team Workflow",
    tools: [
      { name: "Postman", icon: <SiPostman /> },
      { name: "Jira", icon: <SiJira /> },
      { name: "GitHub Actions", icon: <SiGithubactions /> },
    ],
  },
  {
    title: "Delivery",
    tools: [
      { name: "Docker", icon: <SiDocker /> },
      { name: "Kubernetes", icon: <SiKubernetes /> },
      { name: "Vercel", icon: <SiVercel /> },
    ],
  },
];

function Toolstack() {
  return (
    <Row className="tool-showcase" style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {toolGroups.map((group) => (
        <Col xs={12} md={4} className="tool-panel-col" key={group.title}>
          <div className="tool-panel">
            <h3>{group.title}</h3>
            <div className="tool-list">
              {group.tools.map((tool) => (
                <span className="tool-pill" key={`${group.title}-${tool.name}`}>
                  {tool.icon}
                  {tool.name}
                </span>
              ))}
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
}

export default Toolstack;
